import { Checkbox, TableCell, Typography } from "@mui/material"
import EditMenuOption from "components/TableMonitoring/Body/RowMenuListActions/EditMenuOption";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updatePatientContentAction } from "redux/reducers/patientContentReducer";
import { AppColors } from "resources/AppColors";
import { formatDate } from "utils/HelperFunctions"

function PatientContentTableRows({ content, isDashboardView }) {
  const [enabled, setEnabled] = useState(content.enabled ? true : false);

  const dispatch = useDispatch()

  const handleEnabled = (event) => {
    dispatch(updatePatientContentAction(content.id, { id: content.id, enabled: event.target.checked }))
    setEnabled(event.target.checked);
  };

  return (
    <>
      <TableCell align="left">
        <Typography variant='body'>{formatDate(content.startDate)}</Typography>
      </TableCell>
      <TableCell align='left'>
        <EditMenuOption
          entity={content.content}
          isParticipantContent={true}
          isDashboardView={isDashboardView}
          textLink={content.content?.title}
        />
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>{formatDate(content.endDate)}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>
          {content.score ? content.score : "No score"}
        </Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>{content.visited ? "Si" : "No"}</Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>
          {content?.firstVisitDate ? formatDate(content.firstVisitDate) : "-"}
        </Typography>
      </TableCell>
      <TableCell align='left'>
        <Typography variant='body'>
          {content.linkVisited ? "Si" : "No"}
        </Typography>
      </TableCell>
      <TableCell align="left">
        {typeof content.enabled === "boolean" &&
          <Checkbox
            checked={enabled}
            onChange={handleEnabled}
            style={{ color: AppColors.PRIMARY }}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
      </TableCell>
    </>
  )
}

export default PatientContentTableRows